import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

const MSWManagementTertiaryCollectionStore = create((set, get) => ({
  MSWManagementTertiaryCollectionReportData: [],
  MSWManagementTertiaryCollectionInnerReportData: [],
  MSWManagementTertiaryCollectionMonthlyReportData: [],
  ieNameList: [],
  loading: false,
  error: null,

  // ================= OUTER REPORT =================
  fetchMSWManagementTertiaryCollectionReport: async (queryParams) => {
    set({ loading: true, error: null });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const mswTertiaryReport = await apiCall({
        url: `${API_BASE_URL1}GVPReports/KPI06TertiaryDeploymentReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        MSWManagementTertiaryCollectionReportData: Array.isArray(mswTertiaryReport)
          ? mswTertiaryReport
          : [],
        loading: false,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      console.log(message || "Error fetching data");

      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          MSWManagementTertiaryCollectionReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          MSWManagementTertiaryCollectionReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message || "Bad Request");
        set({
          MSWManagementTertiaryCollectionReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          MSWManagementTertiaryCollectionReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      else {
        toast.error(error.message || "Something went wrong");
        set({
          MSWManagementTertiaryCollectionReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }
    } finally {
      set({ loading: false });
    }
  },

  // ================= INNER REPORT =================
  fetchMSWManagementTertiaryCollectionInnerReport: async (queryParams) => {
    set({ loading: true, error: null });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const mswTertiaryInnerReport = await apiCall({
        url: `${API_BASE_URL1}GVPReports/KPI06TertiaryInnerReport?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        MSWManagementTertiaryCollectionInnerReportData: Array.isArray(mswTertiaryInnerReport)
          ? mswTertiaryInnerReport
          : [],
        loading: false,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;
      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          MSWManagementTertiaryCollectionInnerReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          MSWManagementTertiaryCollectionInnerReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message );
        set({
          MSWManagementTertiaryCollectionInnerReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          MSWManagementTertiaryCollectionInnerReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      else {
        toast.error(error.message || "Something went wrong");
        set({
          MSWManagementTertiaryCollectionInnerReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }
    } finally {
      set({ loading: false });
    }
  },

  // ================= MONTHLY REPORT =================
  fetchMSWManagementMonthlyTertiaryCollectionReport: async (queryParams) => {
    set({ loading: true, error: null });

    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const mswTertiaryMonthlyReport = await apiCall({
        url: `${API_BASE_URL1}KpiReport/PlannedAndDeployedTertiaryVehiclesSummaryMonthly?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        MSWManagementTertiaryCollectionMonthlyReportData: Array.isArray(mswTertiaryMonthlyReport)
          ? mswTertiaryMonthlyReport
          : [],
        loading: false,
      });

    } catch (error) {

      const status = error.response?.status;
      const message = error.response?.data?.message;

      if (status === 401) {
        toast.error("Session expired. Please login again.");
        localStorage.removeItem("token");
        window.location.href = "/login";

        set({
          MSWManagementTertiaryCollectionMonthlyReportData: [],
          error: "Unauthorized",
          loading: false,
        });
      }

      else if (status === 400) {
        toast.error(error.message || "Bad Request");
        set({
          MSWManagementTertiaryCollectionMonthlyReportData: [],
          error: message || "Bad Request",
          loading: false,
        });
      }

      else if (status === 404) {
        toast.error(error.message );
        set({
          MSWManagementTertiaryCollectionMonthlyReportData: [],
          error: "No Data found.",
          loading: false,
        });
      }

      else if (status === 500) {
        toast.error("Internal Server Error");
        set({
          MSWManagementTertiaryCollectionMonthlyReportData: [],
          error: "Internal Server Error",
          loading: false,
        });
      }

      else {
        toast.error(error.message || "Something went wrong");
        set({
          MSWManagementTertiaryCollectionMonthlyReportData: [],
          error: message || "Something went wrong",
          loading: false,
        });
      }
    } finally {
      set({ loading: false });
    }
  },

}));

export default MSWManagementTertiaryCollectionStore;
